import './CategoryFilter.css';

/** Filtre par catégorie sous forme de chips cliquables (remplace un <select> générique). */
export function CategoryFilter({ categories, value, onChange, ariaLabel = 'Filtrer par catégorie' }) {
  if (!categories?.length) return null;

  return (
    <div className="filter-chips" role="group" aria-label={ariaLabel}>
      <button
        type="button"
        className={`filter-chip ${!value ? 'filter-chip--active' : ''}`}
        onClick={() => onChange('')}
      >
        Toutes les catégories
      </button>
      {categories.map((cat) => (
        <button
          key={cat.id}
          type="button"
          className={`filter-chip ${value === String(cat.id) ? 'filter-chip--active' : ''}`}
          onClick={() => onChange(String(cat.id))}
        >
          {cat.nom}
        </button>
      ))}
    </div>
  );
}
